import React, { Component } from "react";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import Fade from "react-reveal/Fade";
import { Form, Alert, Spinner, Modal, Button } from "react-bootstrap";
import CustomHelmet from "../components/CustomHelmet";
import axios from "axios";
import { Link } from "react-router-dom";

const url = "https://www.hubsquares.com/php_files/processSignup.php/";
export default class Register extends Component {
  state = {
    user: {
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      username: "",
      password: "",
    },
    error: false,
    errorValue: "",
    validated: false,
    loading: false,
    show: false,
    agree: true,
  };
  componentDidMount() {
    setTimeout(() => {
      this.setState({ show: true });
    }, 2000);
  }

  handleSubmit = async (event) => {
    this.setState({ loading: true });
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    }
    event.preventDefault();
    this.setState({ validated: true });
    await axios.post(url, { ...this.state.user }).then(({ data }) => {
      if (data.success === 1) {
        this.setState({ loading: true });

        this.props.history.push(
          `/complete-register/name=${this.state.user.firstname}`
        );
      } else if (data.success === 0) {
        this.setState({ errorValue: data.msg, error: true, loading: false });
      }
    });
  };
  render() {
    const {
      firstname,
      lastname,
      email,
      phone,
      username,
      password,
    } = this.state.user;
    return (
      <div>
        <CustomHelmet page="Register" />

        <Navbar />
        <div className="wrapper register_banner position-relative">
          <div className="overlay">
            <div className="banner">
              <div className=" text-center mt-6 container">
                <div className="row">
                  <div className="col-3"></div>
                  <div className="col-md-6 col-sm-12">
                    <h1 className="mb-3">Sign Up</h1>
                    {this.state.error && (
                      <Fade bottom collapse when={this.state.error}>
                        <Alert variant="danger">{this.state.errorValue}</Alert>
                      </Fade>
                    )}
                    <p>Enter you credentials to continue</p>
                    <Form
                      noValidate
                      validated={this.state.validated}
                      onSubmit={this.handleSubmit}
                    >
                      <div className="form-group mb-2">
                        <div className="input-group">
                          <i className="fal fa-user-circle position-absolute icon-l "></i>
                        </div>
                        <input
                          required
                          type="text"
                          className="form-control pl-5 mb-4 input-pad form-control-lg"
                          placeholder="Firstname"
                          value={firstname}
                          onChange={(e) =>
                            this.setState({
                              user: {
                                ...this.state.user,
                                firstname: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="form-group mb-2">
                        <div className="input-group">
                          <i className="fal fa-user-circle position-absolute icon-l "></i>
                        </div>
                        <input
                          required
                          type="text"
                          className="form-control pl-5 mb-4 input-pad form-control-lg"
                          placeholder="Lastname"
                          value={lastname}
                          onChange={(e) =>
                            this.setState({
                              user: {
                                ...this.state.user,
                                lastname: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="form-group mb-2">
                        <div className="input-group">
                          <i className="fa fa-envelope position-absolute icon-l "></i>
                        </div>
                        <input
                          required
                          type="email"
                          className="form-control pl-5 mb-4 input-pad form-control-lg"
                          placeholder="Email"
                          value={email}
                          onChange={(e) =>
                            this.setState({
                              user: {
                                ...this.state.user,
                                email: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="form-group mb-2">
                        <div className="input-group">
                          <i
                            className="fa fa-phone position-absolute icon-l"
                            style={{ transform: "rotate(90deg)" }}
                            aria-hidden="true"
                          ></i>
                        </div>
                        <input
                          required
                          type="text"
                          className="form-control pl-5  mb-4  input-pad form-control-lg"
                          placeholder="Phone"
                          value={phone}
                          onChange={(e) =>
                            this.setState({
                              user: {
                                ...this.state.user,
                                phone: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="form-group mb-2">
                        <div className="input-group">
                          <i className="fal fa-user-circle position-absolute icon-l "></i>
                        </div>
                        <input
                          required
                          type="text"
                          className="form-control pl-5 mb-4 input-pad form-control-lg"
                          placeholder="Username"
                          value={username}
                          onChange={(e) =>
                            this.setState({
                              user: {
                                ...this.state.user,
                                username: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="form-group">
                        <div className="input-group">
                          <i
                            className="fa fa-lock position-absolute icon-l"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <input
                          required
                          type="password"
                          className="form-control pl-5 input-pad form-control-lg"
                          placeholder="Password"
                          value={password}
                          minLength="5"
                          onChange={(e) =>
                            this.setState({
                              user: {
                                ...this.state.user,
                                password: e.target.value,
                              },
                            })
                          }
                        />
                        <Form.Text muted>
                          password must be greater than 5
                        </Form.Text>
                      </div>
                     
                      <Form.Group>
                        <Form.Check
                          required
                          label="Agree to terms and conditions"
                          feedback="You must agree before submitting."
                          className="fs-16"
                          onChange={() =>
                            this.setState({ agree: !this.state.agree })
                          }
                        />
                      </Form.Group>
                      <button
                        disabled={this.state.agree}
                        type="submit"
                        className="btn border-0 form-control mt-4 d-flex justify-content-center  auth-btn btn-danger btn-lg addbtn"
                      >
                        Continue
                        {this.state.loading && (
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                      </button>
                    </Form>
                    <p className="my-3">
                      For existing users{" "}
                      <Link to="/login" className="text-white">
                        Login
                      </Link>
                    </p>
                  </div>
                  <div className="col-3"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <Modal
          show={this.state.show}
          onHide={() => this.setState({ show: false })}
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Terms and Conditions of Hubsquares</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <h5 className="font-weight-bold">1. Agreement to Terms</h5>
              <p className="mt-4">
                1.1 These Terms and Conditions constitute a legally binding
                agreement made between you, whether personally or on behalf of
                an entity (<span className="font-weight-bold">you</span>), and
                <span className="font-weight-bold">Hubsquares</span>, located in
                the{" "}
                <span className="font-weight-bold">
                  United Kingdom (we, us)
                </span>
                , concerning your access to and use of the Hubsquares website as
                well as any related applications (the{" "}
                <span className="font-weight-bold">Site</span>).
              </p>
              <p>
                The Site provides the following services:{" "}
                <span className="font-weight-bold">
                  Online business directory for business owners to connect with
                  users (Services)
                </span>
                . You agree that by accessing the Site and/or Services, you have
                read, understood, and agree to be bound by all of these Terms
                and Conditions.
              </p>
              <p>
                <span className="font-weight-bold">
                  If you do not agree with all of these Terms and Conditions,
                  then you are prohibited from using the Site and Services and
                  you must discontinue use immediately
                </span>
                . We recommend that you print a copy of these Terms and
                Conditions for future reference.
              </p>

              <p className="mt-4">
                1.2 The supplemental policies set out in Section 1.7 below, as
                well as any supplemental terms and condition or documents that
                may be posted on the Site from time to time, are expressly
                incorporated by reference.
              </p>

              <p className="mt-4">
                1.3 We may make changes to these Terms and Conditions at any
                time. The updated version of these Terms and Conditions will be
                indicated by an updated “Revised” date and the updated version
                will be effective as soon as it is accessible. You are
                responsible for reviewing these Terms and Conditions to stay
                informed of updates. Your continued use of the Site represents
                that you have accepted such changes.
              </p>

              <p className="mt-4">
                1.4 We may update or change the Site from time to time to
                reflect changes to our products, our users' needs and/or our
                business priorities.
              </p>
              <p className="mt-4">
                1.5 The information provided on the Site is not intended for
                distribution to or use by any person or entity in any
                jurisdiction or country where such distribution or use would be
                contrary to law or regulation or which would subject us to any
                registration requirement within such jurisdiction or country.
              </p>
              <p className="mt-4">
                1.6 The Site is intended for users who are at least 18 years
                old. If you are under the age of 18, you are not permitted to
                register for the Site or use the Services without parental
                permission.
              </p>
              <p className="mt-4">
                1.6 The Site is intended for users who are at least 18 years
                old.
              </p>
              <ul className="ml-4">
                <li>
                  If you are under the age of 18, you are not permitted to
                  register for the Site or use the Services without parental
                  permission.
                </li>
              </ul>
              <h5 className="font-weight-bold">2. Acceptable Use</h5>
              <p className="mt-4">
                2.1 You may not access or use the Site for any purpose other
                than that for which we make the site and our services available.
                The Site may not be used in connection with any commercial
                endeavors except those that are specifically endorsed or
                approved by us.
              </p>

              <p className="mt-4">
                2.2 As a user of this Site, you agree not to:
              </p>
              <ul className="ml-4">
                <li>2.2 As a user of this Site, you agree not to: </li>
                <li>
                  Make any unauthorized use of the Site, including collecting
                  usernames and/or email addresses of users to send unsolicited
                  email or creating user accounts under false pretenses
                </li>
                <li>
                  Use a buying agent or purchasing agent to make purchases on
                  the Site
                </li>
                <li>Use the Site to advertise or sell goods and services </li>
                <li>
                  Circumvent, disable, or otherwise interfere with
                  security-related features of the Site, including features that
                  prevent or restrict the use or copying of any content or
                  enforce limitations on the use
                </li>
                <li>
                  Engage in unauthorized framing of or linking to the Site
                </li>
                <li>
                  Trick, defraud, or mislead us and other users, especially in
                  any attempt to learn sensitive account information such as
                  user passwords
                </li>
                <li>
                  Make improper use of our support services, or submit false
                  reports of abuse or misconduct
                </li>
                <li>
                  Engage in any automated use of the system, such as using
                  scripts to send comments or messages, or using any data
                  mining, robots, or similar data gathering and extraction tools
                </li>
                <li>
                  Interfere with, disrupt, or create an undue burden on the Site
                  or the networks and services connected to the Site
                </li>
                <li>
                  Attempt to impersonate another user or person, or use the
                  username of another user
                </li>
                <li>Sell or otherwise transfer your profile</li>
                <li>
                  Use any information obtained from the Site in order to harass,
                  abuse, or harm another person
                </li>
                <li>
                  Use the Site or our content as part of any effort to compete
                  with us or to create a revenue-generating endeavor or
                  commercial enterprise
                </li>
                <li>
                  Decipher, decompile, disassemble, or reverse engineer any of
                  the software comprising or in any way making up a part of the
                  Site
                </li>
                <li>
                  Attempt to access any portions of the Site that you are
                  restricted from accessing
                </li>
                <li>
                  Harass, annoy, intimidate, or threaten any of our employees,
                  agents, or other users
                </li>
                <li>
                  Delete the copyright or other proprietary rights notice from
                  any of the content
                </li>
                <li>
                  Copy or adapt the Site’s software, including but not limited
                  to Flash, PHP, HTML, JavaScript, or other code
                </li>
                <li>
                  Upload or transmit (or attempt to upload or to transmit)
                  viruses, Trojan horses, or other material that interferes with
                  any party’s uninterrupted use and enjoyment of the Site, or
                  any material that acts as a passive or active information
                  collection or transmission mechanism
                </li>
                <li>
                  Use, launch, or engage in any automated use of the system,
                  such as using scripts to send comments or messages, robots,
                  scrapers, offline readers, or similar data gathering and
                  extraction tools
                </li>
                <li>
                  Disparage, tarnish, or otherwise harm, in our opinion, us
                  and/or the Site
                </li>
                <li>
                  Use the Site in a manner inconsistent with any applicable laws
                  or regulations
                </li>
                <li>
                  Threaten users with negative feedback or offering services
                  solely to give positive feedback to users
                </li>
                <li>
                  Misrepresent experience, skills, or information about a User
                </li>
                <li>Advertise products or services not intended by us</li>
                <li>
                  Falsely imply a relationship with us or another company with
                  whom you do not have a relationship
                </li>
              </ul>
              <h5 className="font-weight-bold">
                Information you provide to us
              </h5>
              <p className="mt-4">
                3.1 You represent and warrant that: (a) all registration
                information you submit will be true, accurate, current, and
                complete and relate to you and not a third party; (b) you will
                maintain the accuracy of such information and promptly update
                such information as necessary; (c) you will keep your password
                confidential and will be responsible for all use of your
                password and account; (d) you ...{" "}
                <Link className="text-dark font-italic" to="/terms-conditions">
                  Contine Reading
                </Link>
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="dark"
              onClick={() => this.setState({ show: false })}
              type="submit"
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
